import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { ModalStartScreenComponent } from '../modal-start-screen/modal-start-screen.component';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-modal-ai-snapshot-auth',
  templateUrl: './modal-ai-snapshot-auth.component.html',
  styleUrls: ['./modal-ai-snapshot-auth.component.scss']
})
export class ModalAiSnapshotAuthComponent implements OnInit, OnDestroy {
  originalImageUrl = 'assets/images/ai-snapshot-original.jpg';
  enhancedImageUrl = 'assets/images/ai-snapshot-enhanced.jpg';

  private authSubscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<ModalAiSnapshotAuthComponent>,
    private dialog: MatDialog,
    private auth: AuthService
  ) {}

  ngOnInit() {
    this.authSubscription = this.auth.isAuthorization.subscribe(isAuthorized => {
      if (isAuthorized) {
        this.dialogRef.close();
      }
    });
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  signIn() {
    this.dialog.open(ModalStartScreenComponent, {
      width: '835px',
      height: '75vh',
      data: 'login-for-ai-snapshot'
    });
  }

  register() {
    this.dialog.open(ModalStartScreenComponent, {
      width: '835px',
      height: '75vh',
      data: 'register'
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-ai-snapshot-auth/modal-ai-snapshot-auth.component.ts